(function () {
  const STORAGE_KEY = 'newsletter_submitted_context';

  function bindForms() {
    document.querySelectorAll('.newsletter-form-wrapper[data-newsletter-context]:not([data-newsletter-bound])').forEach((wrapper) => {
      const form = wrapper.querySelector('form.newsletter-form');
      if (!form) return;

      wrapper.setAttribute('data-newsletter-bound', '');
      form.addEventListener('submit', () => {
        sessionStorage.setItem(STORAGE_KEY, wrapper.dataset.newsletterContext);
      });
    });
  }

  function revealFeedback() {
    if (document.documentElement.dataset.newsletterFeedbackRevealed === 'true') return;

    const submittedContext = sessionStorage.getItem(STORAGE_KEY);
    if (!submittedContext) return;

    const wrapper = document.querySelector(`.newsletter-form-wrapper[data-newsletter-context="${CSS.escape(submittedContext)}"]`);
    if (!wrapper) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    const feedback = wrapper.querySelector('.newsletter-form__feedback');
    if (!feedback) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    wrapper.querySelectorAll('.newsletter-form__feedback').forEach((element) => {
      element.hidden = false;
    });

    document.documentElement.dataset.newsletterSubmitted = submittedContext;
    document.documentElement.dataset.newsletterFeedbackRevealed = 'true';
    sessionStorage.removeItem(STORAGE_KEY);
  }

  bindForms();
  revealFeedback();
})();
